import { Box, Button, Column, Columns, Text, useTheme } from "@seneca/senekit";

import { WarningTriangleInCircle as WarningTriangle } from "features/common/icons";
import { Var } from "features/common/localisation";

import styles from "./SubscriptionRequiresAction.module.scss";
import { Props } from "./types";

const SubscriptionRequiresAction = ({
  packageName,
  onButtonClick,
  paymentFailed,
  paymentRequiresAuthentication,
  buttonDisabled,
  upgrading
}: Props) => {
  const buttonText = paymentFailed
    ? "Retry payment"
    : paymentRequiresAuthentication
      ? "Authenticate"
      : null;
  const text = (
    <>
      The payment for your{" "}
      <b className={styles.package}>
        Seneca <Var>{packageName}</Var>
      </b>{" "}
      {upgrading ? <>upgrade</> : <>package</>}{" "}
      {paymentFailed ? (
        <>failed. Retry to get access.</>
      ) : paymentRequiresAuthentication ? (
        <>
          requires additional checks from your bank. Please authenticate to get
          access.
        </>
      ) : (
        <>failed. Please get in touch to resolve this.</>
      )}
    </>
  );
  const theme = useTheme();

  return (
    <Box
      backgroundColor={theme.foreground}
      borderRadius="large"
      padding={["large", "xlarge"]}
      marginY="large"
    >
      <Columns
        alignX="center"
        space={["large", "xlarge"]}
        collapseBelow="tablet"
        alignY="center"
      >
        <Column width="content">
          <WarningTriangle />
        </Column>
        <Column>
          <Text>{text}</Text>
        </Column>
        <Column width="content">
          {buttonText && (
            <Button
              width="content"
              onClick={onButtonClick!}
              disabled={buttonDisabled}
            >
              {buttonText}
            </Button>
          )}
        </Column>
      </Columns>
    </Box>
  );
};

export { SubscriptionRequiresAction };
